export enum ResourceCopilotDataEventObjectsEnum {
  SETTINGS_AI_RESOURCE_COPILOT = 'settings_ai_resource_copilot',
}

export enum ResourceCopilotOutcomesEnum {
  SAVED = 'saved',
  DISCARDED = 'discarded',
  ABANDONED = 'abandoned',
  REFINED = 'refined',
  ERROR = 'error',
}
